import CloseIcon from '@mui/icons-material/Close';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
} from '@mui/material';
import React from 'react';
import { ModalProps } from '../../types/modal';
import SpaceCard from './SpaceCard';
import { ModifiedSpace } from './Spaces/IndividualSpace';
import { SpaceType } from '../../enums/experience';

interface Props extends ModalProps {
    spaces: ModifiedSpace[];
    selectedSpace?: ModifiedSpace;
    maxNumberOfBeds: number;
}

export const sortSpacesByType = (spaces: Array<any>) => {
    const spaceTypeOrder = [
        SpaceType.Bedroom,
        SpaceType.LivingRoom,
        SpaceType.DiningArea,
        SpaceType.Boardroom,
        SpaceType.GameRoom,
        SpaceType.Garage,
        SpaceType.Kitchen,
        SpaceType.Bathroom,
    ];

    return [...spaces].sort((a, b) => {
        return (
            spaceTypeOrder.indexOf(a.spaceType) -
            spaceTypeOrder.indexOf(b.spaceType)
        );
    });
};

const IndividualExperienceSpacesModal = ({
    open,
    onClose,
    spaces,
    selectedSpace,
    maxNumberOfBeds,
}: Props) => {
    const sortedSpaces = sortSpacesByType(spaces);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth='md'
            fullWidth
            PaperProps={{
                sx: { height: 730 },
            }}
        >
            <DialogTitle>
                Space Configurations
                <IconButton
                    onClick={onClose}
                    size='small'
                    aria-label='close'
                    sx={{ color: 'text.primary' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    sx={{
                        mb: 3,
                        fontWeight: 700,
                        color: 'text.primary',
                        fontSize: '14px',
                    }}
                >
                    Explore the amenities and features offered in this
                    experience.
                </DialogContentText>
                <Grid container spacing={4}>
                    {sortedSpaces.map((space, index) => (
                        <Grid item xs={12} md={6} key={space.name ?? index}>
                            <SpaceCard
                                space={space}
                                selected={
                                    selectedSpace
                                        ? selectedSpace.name === space.name
                                        : false
                                }
                                maxNumberOfBeds={maxNumberOfBeds}
                                cursor='default'
                            />
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default IndividualExperienceSpacesModal;
